const verify = {
  "verify.title": "تأكيد الكود",
  "verify.subtitle": "أدخل الكود المرسل إلى",
  "verify.codeLabel": "كود التحقق",
  "verify.codePlaceholder": "123456",
  "verify.submit": "تأكيد وتسجيل الدخول",
  "verify.verifying": "جاري التحقق...",
  "verify.error.invalidOtp": "الرجاء إدخال كود تحقق صحيح",
  "verify.error.expired": "انتهت الجلسة. الرجاء العودة وإدخال رقم الهاتف مرة أخرى.",
  "verify.error.wrongOtp": "كود تحقق غير صحيح",
  "verify.expired.title": "انتهت الجلسة",
  "verify.expired.message": "الرجاء العودة وإدخال رقم الهاتف مرة أخرى.",
  "verify.expired.backToLogin": "العودة لتسجيل الدخول",
  "verify.wrongNumber": "رقم خطأ؟",
  "verify.goBack": "العودة",
};

export default verify;